﻿import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, FormGroupDirective } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APIEntityService } from '../../_services/entity/API-entity';
import { APIComplaintsService } from '../../_services/complaints/API-complaints'
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { formatDate } from '@angular/common';
import { Constants } from '../../../../_utils/Constants';


//below code for Current Data
const now = new Date();
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');


@Component({
	selector: 'app-complaint-registration-subscriber-01',
	templateUrl: './complaint-registration-subscriber-01.component.html',
	styleUrls: ['./complaint-registration-subscriber-01.component.css'],

})
export class ComplaintRegistrationSubscriber01Component implements OnInit {
	@ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;

	email: any;
	mobileno: any;
	UrnFromURL: any;
	delno: any;
	mob: any;
	dell: any;
	AreaCd: any
	public hide = true;
	response: any;
	public othersFlag: boolean = false;
	public ishide: boolean = false;

	public emailmobotp: boolean = false;
	public verifyinfo: boolean = false;
	public clicked: boolean = false;
	public isDisabled: boolean = false;
	public isReadonly: boolean = false;
	public emailVerify: boolean = false;
	public mobileVerify: boolean = false;
	public resendOtp: boolean = false;
	otpEExp: any;
	otpMExp: any;
	otpEmail: any;
	otpMobile: any;
	public sendOtp: Boolean = true;
	complaintForm: FormGroup;
	isReadonlyTop: boolean = false;
	isMobileEmail: boolean = false;
	isVarify: boolean = false;
	verifiedOtp: boolean;
	disableOtpText: boolean;
	constructor(private fb: FormBuilder,
		private ls: APIEntityService,
		private $modal: $ModalManagerService,
		private cs: APIComplaintsService,
		private db: $DBManagerService,
		private _route: ActivatedRoute,
		private router: Router) {
		this._route.params.subscribe((params) => {
			this.UrnFromURL = params['urn'];
		})
	}

	get f() { return this.complaintForm.controls; }

	numberreg = '^[1-9][0-9]*$';


	ngOnInit() {
		this.complaintForm = this.fb.group({
			// Area_Code: ['', [Validators.required, Validators.pattern("[1-9][0-9]{3}"),  Validators.minLength(4)]],
			// Area_Code: ['', [Validators.required, Validators.pattern("^((?!(0))[0-9])"), Validators.minLength(2), Validators.maxLength(4)]],
			Area_Code: ['', [Validators.required, Validators.pattern(this.numberreg), Validators.minLength(2), Validators.maxLength(4)]],
			delNum: ['', [Validators.required, Validators.pattern(this.numberreg), Validators.minLength(6), Validators.maxLength(8)]],
			mobileNumber: ['', [Validators.required, Validators.pattern("[6-9][0-9]{9}"), Validators.minLength(10)]],
			emailAddress: ['', [Validators.pattern('^[A-Za-z][A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,5}$')]],
			otp: ['', [Validators.required, Validators.pattern("[1-9][0-9]{3}"), Validators.minLength(4), Validators.maxLength(4)]],
			// email_otp: ['', [Validators.required, Validators.pattern("[1-9][0-9]{3}"), Validators.minLength(4)]],
			// mobile_otp: ['', [Validators.required, Validators.pattern("[1-9][0-9]{3}"), Validators.minLength(4)]],		

		});
	}//end of oninit

	hideClick() {
		this.hide = !this.hide;
	}

	onVerify() {
		if (this.complaintForm.controls['Area_Code'].status === "INVALID") {
			alert("Please fill Area Code");
			return true;
		}

		if (this.complaintForm.controls['delNum'].status === "INVALID") {
			alert("Please fill DEL number");
			return true;
		}


		// this.complaintForm.controls['Area_Code'].setValidators([Validators.required, Validators.pattern("[1-9][0-9]{9}"), Validators.minLength(3)])
		// this.complaintForm.controls['delNum'].setValidators([Validators.required, Validators.pattern("[1-9][0-9]{9}"), Validators.minLength(10)])

		// this.AreaCd = this.complaintForm.get("Area_Code").value;
		// this.dell = this.complaintForm.get("delNum").value;
		var AreaCode = this.complaintForm.get("Area_Code").value;
		var delNum = this.complaintForm.get("delNum").value;

		let del = AreaCode.toString() + delNum.toString();

		if (del.length == 10) {
			this.verifyinfo = true;
		}
		else {
			alert("Combination of Area code and Del no should be 10 digits");
			return;
		}

		let data = {
			"delNumber": del,
		}

		console.log("form :", data)

		this.cs.verifyDelNumber(data)
			.subscribe(r => {
				console.log("response -- ", r)
				if (r.message == "DELNoExists") {
					this.$modal.errorModal({
						title: 'Complaint Registration',
						msg: 'Check Del Number'
					})

				}

				else if (r.status == true) {
					//this.showSumbit = false
					this.$modal.successModal({
						title: 'Complaint Registration',
						msg: r.message
					})
					this.isReadonlyTop = true;
					this.isMobileEmail = true;
					this.isVarify = true;
				} else if (r.status == false) {
					this.$modal.errorModal({
						title: 'Complaint Registration',
						msg: r.message
					})

				}

			})
	}




	count: number = 0;
	SendOtpInfo(msg) {
		if (this.complaintForm.controls['mobileNumber'].status === "INVALID" || this.complaintForm.controls['emailAddress'].status === "INVALID") {
			alert("Please fill the mandatory fields");
			return true;
		}

		if (this.othersFlag) {
			alert("Please fill in the mandatory fields");
			return true;
		}
		if (msg === 'Resend') {
			this.count++;
			this.verifiedOtp = true;
			console.log("this verified otp", this.verifiedOtp, this.count)
			if (this.count >= 4) {
				this.verifiedOtp = true;
				this.$modal.errorModal({
					title: 'Resend OTP',
					msg: 'You have exceeded resend OTP three times, Kindly check Mobile number and try again.'
				});
				return;
			}
		}

		// this.complaintForm.controls['delNumber'].setValidators([Validators.required, Validators.pattern("[1-9][0-9]{9}"), Validators.minLength(10)])
		// this.complaintForm.controls['mobileNumber'].setValidators([Validators.required, Validators.pattern("[1-9][0-9]{9}"), Validators.minLength(10)])
		// this.complaintForm.controls['emailAddress'].setValidators([Validators.required, Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,5}$')])

		var mob = this.complaintForm.get("mobileNumber").value;
		var emailid = (this.complaintForm.get("emailAddress").value).trim();
		var AreaCode = this.complaintForm.get("Area_Code").value;
		var delNum = this.complaintForm.get("delNum").value;

		let del = AreaCode.toString() + delNum.toString();


		let data = {
			"delNumber": del,
			"emailAddress": (emailid.length > 0) ? emailid : 'noreplydlt@email.com',
			"mobileNumber": mob
		}

		this.verifyinfo = true;

		this.cs.checkDelEmailMobile(data)
			.subscribe(r => {
				console.log("response -- ", r)
				if (r.status == true) {
					this.$modal.successModal({
						title: msg + 'OTP',
						msg: 'OTP has been sent successfully!'
					})
					this.isReadonly = true;
					this.verifiedOtp = true;
					setTimeout(() => {
						this.verifiedOtp = false;
					}, 90000);
					this.sendOtp = false;
					this.emailmobotp = true;
					this.clicked = false;
					// if(msg=='Resend'){
					// 	this.verifiedOtp = true;


					// }

				} else {
					this.$modal.errorModal({
						title: msg + 'OTP',
						msg: r.message
					});

				}

			})

	}


	verifyOTP() {
		let emailAdd = (this.complaintForm.get('emailAddress').value).trim()
		this.mob = this.complaintForm.get('mobileNumber').value;
		this.email = (emailAdd.length > 0) ? emailAdd : 'noreplydlt@email.com';
		this.AreaCd = this.complaintForm.get('Area_Code').value;
		this.dell = this.complaintForm.get('delNum').value;

		this.delno = this.AreaCd.toString() + this.dell.toString();

		var data = {
			"otp": this.complaintForm.get("otp").value,
			"mobileNumber": this.mob,
			"emailAddress": this.email,
			"delNumber": this.delno
		}


		this.cs.sendOTP(data)

			.subscribe(r => {

				if (r.status == true) {

					this.db.set(Constants.SESSSION_STORAGE, Constants.COMPLAINT_EMAIL, this.email);
					this.db.set(Constants.SESSSION_STORAGE, Constants.COMPLAINT_MOBILE, this.mob);
					this.db.set(Constants.SESSSION_STORAGE, Constants.COMPLAINT_AREACODE, this.AreaCd);
					this.db.set(Constants.SESSSION_STORAGE, Constants.COMPLAINT_DELNUMBER, this.dell);

					this.$modal.successModal({
						title: 'Verify OTP',
						msg: 'OTP Verified'
					});
					this.disableOtpText = true;
					this.verifiedOtp = true;
					this.mobileVerify = true;
					this.resendOtp = false;
					this.clicked = true;
					// setTimeout(() => {
					// 	this.resendOtp = false;
					// 	if(this.count == 3){
					// 		this.resendOtp=true;
					// 	}
					// }, 9000);
				}
				else if (r.status == false) {
					if (r.status == false) {
						this.$modal.errorModal({
							title: 'Verify OTP',
							msg: r.message
						});
						// setTimeout(() => {
						// 	this.verifiedOtp = false;
						// 	if(this.count == 3){
						// 		this.verifiedOtp=true;
						// 	}
						// }, 90000);
					}
				}
			})
	}
	reset() {
		this.formGroupDirective.resetForm();
		this.isReadonlyTop = false;
		this.isVarify = false;
		this.isMobileEmail = false;
		this.isReadonly = false;
		this.sendOtp = false;
		this.emailmobotp = false;
		this.verifyinfo = false;
		this.sendOtp = true;
		this.disableOtpText = false;
		this.verifiedOtp = false;
		this.count = 0;

	}




	onSubmitCF() {
		this.router.navigateByUrl('/complaint-registration-subscriber-02');

	}

	downloadPrivacyprocess(){
		let link =document.createElement('a');
		link.setAttribute('type', 'hidden');
		link.href = '../../../../../assets/Privacy Policy.pdf';
		link.download = 'Privacy Policy Process';
		document.body.appendChild(link);
		link.click();
		link.remove();
	  }
	  downloadTermsprocess(){
		let link =document.createElement('a');
		link.setAttribute('type', 'hidden');
		link.href = '../../../../../assets/Terms of Use.pdf';
		link.download = 'Terms of Use Process';
		document.body.appendChild(link);
		link.click();
		link.remove();
	  }

}